import React, { Component, ReactElement } from 'react'
import { observer, inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { Input, Select } from 'antd'
import { OptionProps } from 'antd/lib/select'
import { AsyncProductInput } from '../../../../../components/GrInput/AsyncProductInput'
import { DiscountStore, TDiscountSearchType } from './DiscountStore'
import { SelectDiscountCategories } from './SelectDiscountCategories'
import { getPopupContainer } from '../../../../../utilities/helpers'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  discountStore: DiscountStore
  filterOption: boolean | ((inputValue: string, option: ReactElement<OptionProps>) => boolean)
}

interface State {
  excludeDiscountType: TDiscountSearchType
  selectedIncludedValue?: string
  selectedExcludedValue?: string
}

@inject('currentCompanyStore')
@observer
export class DiscountCategories extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      excludeDiscountType: 'category',
    }
  }

  render() {
    return (
      <>
        <div className='caption mb-2'>
          <strong>Choose categories to include</strong>
        </div>

        <SelectDiscountCategories
          value={this.state.selectedIncludedValue}
          onSelect={(categoryId) => {
            this.props.discountStore.addNewDiscountByCategory('include', categoryId)
            this.setState({ selectedIncludedValue: undefined })
          }}
          style={{ width: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}
          discountStore={this.props.discountStore}
          discountOption='include'
          disableOption='selected'
        />

        {this.props.discountStore.isParentCategoryIncluded && (
          <>
            <hr className='mb-3' />

            <div className='caption mb-2'>
              <strong>Choose sub-categories or products to exclude</strong>
            </div>

            <Input.Group style={{ display: 'flex', flexWrap: 'wrap' }} compact>
              <Select<TDiscountSearchType>
                defaultValue={this.state.excludeDiscountType}
                dropdownMatchSelectWidth={false}
                onChange={(excludeDiscountType) =>
                  this.setState({ excludeDiscountType, selectedExcludedValue: undefined })
                }
                getPopupContainer={getPopupContainer}
              >
                <Select.Option value='product'>Product</Select.Option>
                <Select.Option value='category'>Sub-category</Select.Option>
              </Select>

              {this.state.excludeDiscountType === 'product' ? (
                <AsyncProductInput
                  showSearch
                  allowClear
                  mode={'default'}
                  style={{ flex: 1 }}
                  placeholder='Search a product'
                  debounceTime={400}
                  dropdownMatchSelectWidth={false}
                  onChange={(product) => {
                    if (product.length === 1) {
                      this.props.discountStore.addNewDiscountByProduct('exclude', product[0])
                    }
                  }}
                  onSelect={() => this.setState({ selectedExcludedValue: undefined })}
                  filterOption={this.props.filterOption}
                  productIdsToHide={this.props.discountStore.getSelectedProductIds('exclude')}
                  selectOptionClassName='discount-select-options'
                />
              ) : (
                <SelectDiscountCategories
                  value={this.state.selectedExcludedValue}
                  onSelect={(categoryId) => {
                    this.props.discountStore.addNewDiscountByCategory('exclude', categoryId)
                    this.setState({ selectedExcludedValue: undefined })
                  }}
                  placeholder={'Select a sub-category'}
                  notFoundContent={'There is no sub-categories to select'}
                  isSubCategorySelect={true}
                  discountStore={this.props.discountStore}
                  discountOption='exclude'
                  disableOption='none'
                />
              )}
            </Input.Group>
          </>
        )}
      </>
    )
  }
}
